import type { NetworkData } from '../modules/wallets/networks/networkProvider/networkProvider.types';
import { BaseError } from './base';

type NetworkNotAddedErrorParams = {
  networkData: NetworkData;
  networkId: string;
  originalError: unknown;
  walletProviderKey: string;
};

export class NetworkNotAddedError extends BaseError {
  readonly networkData: NetworkData;

  constructor({
    networkData,
    networkId,
    originalError,
    walletProviderKey,
  }: NetworkNotAddedErrorParams) {
    const cause = originalError instanceof Error ? originalError : null;

    super({
      cause,
      code: 'network_not_added',
      docsUrl: null,
      metaMessages: [
        `Wallet provider key: ${walletProviderKey}`,
        `Network ID: ${networkId}`,
        'The network is not added to the wallet. If the wallet provider supports adding networks, call the `addNetwork` method before switching.',
        'The network data is available in the error payload as `error.networkData` and can be passed directly to `addNetwork`.',
      ],
      name: 'NetworkNotAddedError',
      shortMessage: `Cannot switch to network ${networkId} because it is not added to the wallet. If the wallet provider supports it, call \`addNetwork\` with the network data from \`error.networkData\` first.`,
    });

    this.networkData = networkData;
  }
}
